import { useLazyQuery } from '@apollo/client';
import { GET_QUESTIONNAIRE_RESPONSE_PAGINATION } from '../gqlSchemes/getQuestionnaireResponsePagination';
import { GET_QUESTIONNAIRE_RESPONSE_BY_ID } from '../gqlSchemes/getQuestionnaireResponseById';
import { useMemo } from 'react';

const useGetQuestionnaireResponses = ({
  startDate,
  endDate,
  patient,
  metricDefinitionId,
}) => {
  const [
    loadQuestionnaireResponses,
    { loading: loadingPagination, data },
  ] = useLazyQuery(GET_QUESTIONNAIRE_RESPONSE_PAGINATION, {
    variables: {
      page: 0,
      perPage: 10,
      patient,
      filter: {
        metricDefinitionId,
        startDate,
        endDate,
      },
    },
    fetchPolicy: 'no-cache', // Add no cache fetch policy
  });

  const [
    loadQuestionnaireResponsesById,
    { loading: loadingById, data: dataById },
  ] = useLazyQuery(GET_QUESTIONNAIRE_RESPONSE_BY_ID, {
    fetchPolicy: 'no-cache',
  });

  const memoAnswersById = useMemo(
    () => [dataById?.questionnaireResponse?.questionnaireResponseById],
    [dataById]
  );

  return {
    questionnaireAnswers:
      data?.questionnaireResponse?.questionnaireResponsesPagination?.items ||
      memoAnswersById ||
      [],
    loadQuestionnaireResponses,
    loadQuestionnaireResponsesById,
    loading: loadingById || loadingPagination,
  };
};

export default useGetQuestionnaireResponses;
